import {  ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { BaseListComponent } from '../../../classes/base-list.component';
import { VssLoadingService } from '../../loading/vss-loading.service';
import { TValidators } from '../../../extensions/validator';
import { Ultilities } from '../../../extensions/ultilities';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {TableColum} from '../table.model';
import {ColumnType} from '../../../vss-ui.enum';

@Component({
  selector: 'vss-ui-update-item-function',
  templateUrl: './update-item-function.component.html',
  styleUrls: ['./update-item-function.component.scss']
})
export class UpdateItemModalComponent extends BaseListComponent implements OnInit {
  tableHeads: TableColum[] = [];
  item: any;
  canEdit: boolean = true;
  isPreview: boolean = false;
  get COLUMN_TYPE() { return ColumnType };
  inputTypeColumn!: number;
  colDateTypes: ColumnType[] = [this.COLUMN_TYPE.DATE_PICKER, this.COLUMN_TYPE.DATE,  this.COLUMN_TYPE.DATE_TIME_PICKER, this.COLUMN_TYPE.DATE_TIME_RANGE_PICKER, this.COLUMN_TYPE.DATE_RANGE_PICKER]
  tableColumnData: TableColum[] = [];
  MAX_LENGTH_TEXT = 256;
  dt = null;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private loadingService: VssLoadingService,
    private message: NzMessageService,
    private cdr: ChangeDetectorRef,
		// private moduleManagementApiService: ModuleManagementApiService,
  ) { super() }

  ngOnInit(): void {
    this.initForm();
    if(this.item)
      this.myForm.patchValue(this.item);
  }

  dropFilterForm(e: CdkDragDrop<string[]>) {
    moveItemInArray(this.tableHeads, e.previousIndex, e.currentIndex);
    this.cdr.detectChanges();
  }
  initForm() {
    let initForm: any = {};
    this.tableHeads.forEach(col => {
      let arrValid = [];
      if(col.addItem && col.addItem.pattern)
        arrValid.push(TValidators.pattern(new RegExp(col.addItem?.pattern), col.addItem?.message));
      if(col.isRequire)
        arrValid.push(TValidators.required());
      initForm[col.name] = [this.item && this.item[col.name] ? this.item[col.name] : undefined, arrValid];
    });
    this.myForm = this.fb.group(initForm);
    if((!this.canEdit && this.item)) { //|| this.isPreview
      this.myForm?.disable()
    }
  }

  getKeyFilter(name:string, type: any) {
    return `${name}_${type}`
  }
  onChangeInputSearch(type: any) {
    this.inputTypeColumn = type;
  }
  getKeyFilterByColName(name:string) {
    const col = this.tableColumnData.find(c => c.name == name || c?.filter?.name == name)
    return col ? `${col?.filter?.name || col?.name}_${col?.filter?.type || col.type}` : name
  }

  closeModal() {
    if(this.isPreview){
      this.modalRef.close(this.tableHeads);
    } else
      this.modalRef.close();
  }

  submit() {
    Ultilities.validateForm(this.myForm);
    if (this.myForm.invalid) {
      return
    }
    let data = {
      ...this.myForm?.getRawValue(),
      functionCode: this.myForm?.getRawValue()?.code?.toUpperCase()
    };
    this.dt = data;
    // this.modalRef.triggerOk();
		this.loadingService.showLoading();
    if(this.isPreview){
      return this.tableHeads;
      // this.modalRef.close(this.tableHeads);
    }else{
      return data;
      // this.modalRef.close(data);
    }
  }

  onChangeColAttrValue(col:TableColum){
    col!.isEditColAttr = false
    col.attr = col.attr || col.name;
  }
}
